import { defineAsyncComponent, markRaw } from 'vue';

const AboutMe = markRaw(defineAsyncComponent(() => import('@/views/MXEditor/editor/AboutMe.vue')));
const AboutMeHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/AboutMeHelp.vue'))
);
const AgentProfileImage = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/AgentProfileImage.vue'))
);
const ProfileImageHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/ProfileImageHelp.vue'))
);
const BannerImage = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/BannerImage.vue'))
);
const BannerImageHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/BannerImageHelp.vue'))
);
const ContactMeHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/ContactMeHelp.vue'))
);
const DesignationsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/DesignationsHelp.vue'))
);
const JobsListing = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/JobsListing.vue'))
);
const JobsHelp = markRaw(defineAsyncComponent(() => import('@/views/MXEditor/help/JobsHelp.vue')));
const LanguagesHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/LanguagesHelp.vue'))
);
const MapsHelp = markRaw(defineAsyncComponent(() => import('@/views/MXEditor/help/MapsHelp.vue')));
const MetaDescription = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/MetaDescription.vue'))
);
const TitleAndMetaHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/TitleAndMetaHelp.vue'))
);
const LocationDetails = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/LocationDetails.vue'))
);
const LocationDetailHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/LocationDetailsHelp.vue'))
);
const MissionStatement = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/MissionStatement.vue'))
);
const MissionStatementHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/MissionStatementHelp.vue'))
);
const PreferredLocations = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/PreferredLocations.vue'))
);
const PreferredLocationsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/PreferredLocationsHelp.vue'))
);
const AgencyDetailsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/AgencyDetailsHelp.vue'))
);
const OfficeHours = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/OfficeHours.vue'))
);
const OfficeHoursHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/OfficeHoursHelp.vue'))
);
const PageTitle = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/PageTitle.vue'))
);
const PhoneDetailsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/PhoneDetailsHelp.vue'))
);
const PhonePrefs = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/PhonePrefs.vue'))
);
const PhonePrefsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/PhonePrefsHelp.vue'))
);
const ProductsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/ProductsHelp.vue'))
);
const SimpleInsights = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/SimpleInsights.vue'))
);
const SimpleInsightsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/SimpleInsightsHelp.vue'))
);
const SocialMedia = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/SocialMedia.vue'))
);
const SocialHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/SocialHelp.vue'))
);
const TeamSettings = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/TeamSettings.vue'))
);
const TeamHelp = markRaw(defineAsyncComponent(() => import('@/views/MXEditor/help/TeamHelp.vue')));
const TeamMembers = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/TeamMembers.vue'))
);
const TeamMemberHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/TeamMemberHelp.vue'))
);
const OfficeAboutUs = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/OfficeAboutUs.vue'))
);
const OfficeAboutUsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/OfficeAboutUsHelp.vue'))
);
const ReviewsPref = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/ReviewsPref.vue'))
);
const ReviewsPrefHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/ReviewsPrefHelp.vue'))
);
const DesktopLayout = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/DesktopLayout.vue'))
);
const DesktopLayoutHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/DesktopLayoutHelp.vue'))
);
const QuoteImage = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/QuoteImage.vue'))
);
const QuoteImageHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/QuoteImageHelp.vue'))
);
const JobsTabUrl = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/JobsTabUrl.vue'))
);
const JobsTabUrlHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/JobsTabUrlHelp.vue'))
);
const QLPWelcomeBanner = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/QLPWelcomeBanner.vue'))
);
const QLPWelcomeBannerHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/QLPWelcomeBannerHelp.vue'))
);
const LocationsImage = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/LocationsImage.vue'))
);
const LocationsImageHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/LocationsImageHelp.vue'))
);
const QLPPhonePrefs = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/QLPPhonePrefs.vue'))
);
const QLPPhonePrefsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/QLPPhonePrefsHelp.vue'))
);
const UpdateContent = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/UpdateContent.vue'))
);
const UpdateContentHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/UpdateContentHelp.vue'))
);
const QLPSocials = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/QLPSocials.vue'))
);
const QLPSocialsHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/QLPSocialsHelp.vue'))
);
const QLPLayout = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/editor/QLPLayout.vue'))
);
const QLPLayoutHelp = markRaw(
	defineAsyncComponent(() => import('@/views/MXEditor/help/QLPLayoutHelp.vue'))
);

const EditorViews = [
	{
		path: 'about-me',
		label: 'About Me',
		icon: 'user-pen',
		overrideTypes: ['agent_about_me'],

		component: AboutMe,
		help: AboutMeHelp,
	},

	{
		path: 'agent-image',
		label: 'Agent Image',
		icon: 'image',
		overrideTypes: ['agent_avatar', 'qlp_agent_avatar'],

		component: AgentProfileImage,
		help: ProfileImageHelp,
	},
	{
		path: 'banner-image',
		label: 'Banner Image',
		icon: 'panorama',
		overrideTypes: ['office_banner'],

		component: BannerImage,
		help: BannerImageHelp,
	},
	{
		path: 'contact-me',
		label: 'Contact Us',
		icon: 'card-account-mail-outline',

		help: ContactMeHelp,
	},
	{
		path: 'designations',
		label: 'Designations',
		icon: 'alphabetical',

		help: DesignationsHelp,
	},
	{
		path: 'jobs-listing',
		label: 'Jobs Listing',
		icon: 'magnifying-glass-dollar',
		overrideTypes: ['jobs_team_images', 'jobs_no_job_message'],

		component: JobsListing,
		help: JobsHelp,
	},
	{
		path: 'languages',
		label: 'Languages',
		icon: 'translate',

		help: LanguagesHelp,
	},
	{
		path: 'maps',
		label: 'Maps',
		icon: 'map',

		help: MapsHelp,
	},
	{
		path: 'meta-description',
		label: 'Meta Description',
		header: 'Page Meta Description',
		icon: 'computer',
		overrideTypes: ['meta_description'],

		component: MetaDescription,
		help: TitleAndMetaHelp,
	},
	{
		path: 'location-details',
		label: 'Location Details',
		icon: 'universal-access',
		overrideTypes: ['location_details'],

		component: LocationDetails,
		help: LocationDetailHelp,
	},
	{
		path: 'mission',
		label: 'Mission',
		icon: 'bullseye',
		overrideTypes: ['office_mission', 'mission_tab_images'],

		component: MissionStatement,
		help: MissionStatementHelp,
	},
	{
		path: 'preferred-locations',
		label: 'Preferred Locations',
		icon: 'city',
		overrideTypes: ['office_preferred_locations'],

		component: PreferredLocations,
		help: PreferredLocationsHelp,
	},
	{
		path: 'agency-details',
		label: 'Agency Details',
		header: 'Name, Address, and Landmark',
		icon: 'format-color-text',

		help: AgencyDetailsHelp,
	},
	{
		path: 'office-hours',
		label: 'Office Hours',
		icon: 'clock',
		overrideTypes: [
			'office_structured_hours',
			'office_timezone',
			'virtual_meeting_toggle',
			'office_holiday_closures',
			'by_appointment',
		],

		component: OfficeHours,
		help: OfficeHoursHelp,
	},
	{
		path: 'page-title',
		label: 'Page Title',
		icon: 'file-circle-info',
		overrideTypes: ['meta_page_title'],

		component: PageTitle,
		help: TitleAndMetaHelp,
	},
	{
		path: 'phone-details',
		label: 'Phone Details',
		header: 'Non-editable Phone Details',
		icon: 'phone',

		help: PhoneDetailsHelp,
	},
	{
		path: 'phone-prefs',
		label: 'Phone Prefs',
		header: 'Phone Prefs',
		icon: 'phone',
		overrideTypes: ['preferred_phone', 'phone_position'],

		component: PhonePrefs,
		help: PhonePrefsHelp,
	},
	{
		path: 'products',
		label: 'Products',
		icon: 'package-variant',

		help: ProductsHelp,
	},

	{
		path: 'simple-insights',
		label: 'Simple Insights',
		icon: 'newspaper',
		overrideTypes: ['articles_blacklist'],

		component: SimpleInsights,
		help: SimpleInsightsHelp,
	},
	{
		path: 'social',
		label: 'Social Media',
		icon: 'thumbs-up',
		overrideTypes: ['social_feeds'],

		component: SocialMedia,
		help: SocialHelp,
	},
	{
		path: 'team',
		label: 'Team - General',
		icon: 'people-group',
		overrideTypes: [
			'team_tab_display',
			'team_description',
			'team_member_order',
			'team_tab_images',
		],

		component: TeamSettings,
		help: TeamHelp,
	},
	{
		path: 'team-members',
		label: 'Team - Members',
		icon: 'user-plus',
		overrideTypes: ['team_member', 'staff_avatar'],

		component: TeamMembers,
		help: TeamMemberHelp,
	},
	{
		path: 'office-about-us',
		label: 'About Us',
		icon: 'users',
		overrideTypes: ['office_about_us'],

		component: OfficeAboutUs,
		help: OfficeAboutUsHelp,
	},
	{
		path: 'reviews',
		label: 'Reviews',
		icon: 'star',
		overrideTypes: ['reviews_social_urls', 'reviews_display_stars', 'reviews_display_carousel'],

		component: ReviewsPref,
		help: ReviewsPrefHelp,
	},
	{
		path: 'desktop-layout',
		label: 'Desktop Layout',
		icon: 'table-pivot',
		overrideTypes: ['quote_alignment'],

		component: DesktopLayout,
		help: DesktopLayoutHelp,
	},
	{
		path: 'quote-image',
		label: 'Quote Image',
		icon: 'image',

		component: QuoteImage,
		help: QuoteImageHelp,
	},
	{
		path: 'jobs-tab-url',
		label: "We're Hiring Tab",
		icon: 'person',
		overrideTypes: ['jobs_tab_enabled'],

		component: JobsTabUrl,
		help: JobsTabUrlHelp,
	},
	{
		path: 'qlp-text-header',
		label: 'Welcome Banner',
		icon: 'door-open',
		overrideTypes: ['qlp_welcome_banner'],

		component: QLPWelcomeBanner,
		help: QLPWelcomeBannerHelp,
	},
	{
		path: 'locations-image',
		label: 'Locations Image',
		icon: 'panorama',
		overrideTypes: ['locations_image'],

		component: LocationsImage,
		help: LocationsImageHelp,
	},
	{
		path: 'phone-toggles',
		label: 'Phone Prefs',
		icon: 'phone',
		overrideTypes: ['qlp_primary_phone', 'qlp_phones'],

		component: QLPPhonePrefs,
		help: QLPPhonePrefsHelp,
	},
	{
		path: 'route-update-content',
		label: 'Update Content',
		icon: 'arrows-rotate',

		component: UpdateContent,
		help: UpdateContentHelp,
	},
	{
		path: 'social-toggles',
		label: 'Social Media',
		icon: 'thumbs-up',
		overrideTypes: ['qlp_socials'],

		component: QLPSocials,
		help: QLPSocialsHelp,
	},
	{
		path: 'qlp-layout',
		label: 'Layout',
		icon: 'table-layout',
		overrideTypes: ['qlp_layout'],

		component: QLPLayout,
		help: QLPLayoutHelp,
	},
];
EditorViews.sort((a, b) => a.label.localeCompare(b.label));

export { EditorViews };
